<template>
  <div>
    <Modal
      @on-cancel="showVerifyModal = false"
      :footer-hide="true"
      :transfer="true"
      :closable="true"
      :mask-closable="false"
      v-model="showVerifyModal"
      title="Verify"
    >
      <div>
        <p
          style="text-align: center; margin-bottom: 10px;"
        >We have sent you a verification code via {{ verifyViaMobile ? "SMS" : "email"}} for verification</p>
        <div class="contact-verify">
          <Input
            class="code-input"
            size="large"
            v-model="verifyCode"
            :disabled="isVerifying"
            placeholder="Enter verification code"
            clearable
          ></Input>
          <Button
            style="width: 70%"
            :loading="isVerifying"
            long
            type="primary"
            @click="verify"
          >Verify</Button>
        </div>
      </div>
    </Modal>
    <Modal
      @on-cancel="showUploadSelection = false"
      :footer-hide="true"
      :transfer="true"
      v-model="showUploadSelection"
      title="Select Upload Method"
    >
      <Row :gutter="20">
        <i-col :span="12">
          <Button long @click="showUploadSelection = false;openAvatarPicker()">Library</Button>
        </i-col>
        <i-col :span="12">
          <Button long @click="showUploadSelection = false;$refs.uploadImage.triggerUpload()">Upload</Button>
        </i-col>
      </Row>
    </Modal>
    <!-- <MyOrganization :profile="profile"></MyOrganization> -->
    <!-- <UserProfileGallery :profile="profile"></UserProfileGallery> -->
    <Card shadow :padding="15" v-if="profile">
      <PublicProfileSW @onChangePublicValue="changePublic" style="margin-bottom: 20px" />
      <NotificationSW></NotificationSW>
    </Card>
    <br />
    <!-- <UserProfileSettingSectionsComponent
      tag="bio"
      :profile="profile"
      title="About Me"
      :fieldslugs="['about_me']"
      icon="ios-paper"
      :hide-check="false"
      info="Tell us about yourself or share a favorite quote">
    </UserProfileSettingSectionsComponent>-->
    <UserProfileSettingPasswordComponent
      tag="password"
      title="Password"
      icon="locked"
      info="Change your password"
    ></UserProfileSettingPasswordComponent>
    <!-- <UserProfileSettingSectionsComponent
      tag="education"
      :profile="profile"
      title="Education"
      :hide-check="true"
      :fieldslugs="['education']"
      icon="university"
      info="Manage your education credentials">
    </UserProfileSettingSectionsComponent>
    <UserProfileSettingSectionsComponent
      tag="accomplishment"
      :profile="profile"
      title="Career Highlights"
      :hide-check="true"
      :fieldslugs="['accomplishment']"
      icon="trophy"
      info="Share the highlights of your career">
    </UserProfileSettingSectionsComponent>
    <UserProfileSettingSectionsComponent
      tag="notable"
      :profile="profile"
      title="Other Notable Information"
      :hide-check="true"
      :fieldslugs="['notable']"
      icon="ribbon-a"
      info="Did you write a book or win an award?">
    </UserProfileSettingSectionsComponent>-->
    <UserProfileSettingSectionsComponent
      tag="details"
      :profile="profile"
      title="Details"
      :hide-check="false"
      :fieldslugs="brandFieldSlugs"
      icon="ios-person"
      info="Manage the details on your profile"
    ></UserProfileSettingSectionsComponent>
    <UserProfileSettingSectionsComponent
      tag="location"
      :profile="profile"
      title="Location"
      :hide-check="false"
      :fieldslugs="['country','state','province','city','zipcode']"
      icon="ios-location"
      info="Manage your location settings"
    ></UserProfileSettingSectionsComponent>
    <!-- <UserProfileSettingSectionsComponent
      tag="contact"
      :profile="profile"
      title="Contact Info"
      :fieldslugs="['contact_number','email']"
      icon="ios-telephone"
      :hide-check="false"
      info="Manage your contact number and email">
    </UserProfileSettingSectionsComponent>-->

    <div class="contact-dropdown">
      <Card shadow :padding="15">
        <Row type="flex" align="middle">
          <i-col :span="24">
            <div @click="openContactInfo = !openContactInfo">
              <Row type="flex" align="middle">
                <i-col :span="3" style="text-align:center">
                  <Icon type="ios-telephone" size="35"></Icon>
                </i-col>
                <i-col :span="19">
                  <p class="section-header">Contact Info</p>
                  <span class="section-label">Manage your contact number and email</span>
                </i-col>
                <i-col :span="2">
                  <Icon :type="openContactInfo ? 'chevron-up':'chevron-down'" style></Icon>
                </i-col>
              </Row>
            </div>
          </i-col>
          <i-col :span="24">
            <div style="height:auto;overflow:hidden">
              <transition
                mode="out-in"
                enter-active-class="animated slideInDown faster"
                leave-active-class="animated slideOutUp faster"
              >
                <div v-show="openContactInfo">
                  <Row type="flex" :gutter="20" style="align-items: center; padding:8px 0">
                    <i-col offset="2" :span="2">
                      <!-- <Checkbox /> -->
                    </i-col>
                    <i-col :span="6">
                      <Row type="flex" :gutter="20" align="middle" style="padding:8px 0">
                        <i-col :span="24" class="section-label m">Email</i-col>
                      </Row>
                    </i-col>
                    <i-col :span="14">
                      <Row
                        v-for="(email, i) in profile.email"
                        :key="i"
                        type="flex"
                        :gutter="20"
                        align="middle"
                        style="padding:2px 0"
                      >
                        <i-col :span="20" class="section-label m">
                          <i-input readonly v-model="profile.email[i].email">
                            <template slot="append">
                              <Icon
                                v-if="email.validated_at"
                                :type="email.validated_at ? 'checkmark-circled' : ''"
                                style="color: var(--success-color)"
                              />
                            </template>
                          </i-input>
                        </i-col>
                        <i-col :span="2" class="contact-control" v-if="email.primary === 0">
                          <Dropdown :transfer="true" placement="bottom-end">
                            <a style="padding:4px 0px; color: black;">
                              <Icon size="20" type="android-more-vertical"></Icon>
                            </a>
                            <DropdownMenu slot="list">
                              <DropdownItem @click.native="removeEmail(true, email.email)">
                                <a>Delete</a>
                              </DropdownItem>
                              <DropdownItem
                                v-if="!email.validated_at"
                                @click.native="sendVerification(false, email.email)"
                              >
                                <a>Verify</a>
                              </DropdownItem>
                              <DropdownItem
                                @click.native="setEmailPrimary(email.email)"
                                v-if="email.validated_at && email.primary !== 1"
                              >
                                <a>Set as primary</a>
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </i-col>
                        <i-col :span="2" class="contact-control" v-else>
                          <Tooltip content="Primary" placement="left">
                            <Icon type="android-star"></Icon>
                          </Tooltip>
                        </i-col>
                      </Row>
                      <Row
                        v-for="(email, i) in emailAdd"
                        :key="i+'a'"
                        type="flex"
                        :gutter="20"
                        align="middle"
                        style="padding:2px 0"
                      >
                        <i-col :span="20" class="section-label m">
                          <i-input v-model="emailAdd[i].email" />
                        </i-col>
                        <i-col :span="2">
                          <Dropdown :transfer="true" placement="bottom-end">
                            <a style="padding:4px 0px; color: black;">
                              <Icon size="20" type="android-more-vertical"></Icon>
                            </a>
                            <DropdownMenu slot="list">
                              <DropdownItem @click.native="removeEmail(false, email.email)">
                                <a>Delete</a>
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </i-col>
                      </Row>
                      <Row style="margin-top: 8px;">
                        <i-col :span="6">
                          <Button @click="addEmail" size="small">
                            <small>Add New</small>
                          </Button>
                        </i-col>
                      </Row>
                    </i-col>
                  </Row>

                  <Row type="flex" :gutter="20" style="align-items: center; padding:8px 0">
                    <i-col offset="2" :span="2">
                      <!-- <Checkbox /> -->
                    </i-col>
                    <i-col :span="6">
                      <Row type="flex" :gutter="20" align="middle" style="padding:8px 0">
                        <i-col :span="24" class="section-label m">Mobile Number</i-col>
                      </Row>
                    </i-col>
                    <i-col :span="14">
                      <Row
                        v-for="(mobile, i) in profile.mobile"
                        :key="i"
                        type="flex"
                        :gutter="20"
                        align="middle"
                        style="padding:2px 0"
                      >
                        <i-col :span="20" class="section-label m">
                          <i-input readonly v-model="profile.mobile[i].mobile">
                            <template slot="append">
                              <Icon
                                v-if="mobile.validated_at"
                                :type="mobile.validated_at ? 'checkmark-circled' : ''"
                                style="color: var(--success-color)"
                              />
                            </template>
                          </i-input>
                        </i-col>
                        <i-col :span="2" class="contact-control" v-if="mobile.primary === 0">
                          <Dropdown :transfer="true" placement="bottom-end">
                            <a style="padding:4px 0px; color: black;">
                              <Icon size="20" type="android-more-vertical"></Icon>
                            </a>
                            <DropdownMenu slot="list">
                              <DropdownItem @click.native="removeMobile(true, mobile.mobile)">
                                <a>Delete</a>
                              </DropdownItem>
                              <DropdownItem
                                v-if="!mobile.validated_at"
                                @click.native="sendVerification(true, mobile.mobile)"
                              >
                                <a>Verify</a>
                              </DropdownItem>
                              <DropdownItem
                                @click.native="setMobilePrimary(mobile.mobile)"
                                v-if="mobile.validated_at && mobile.primary !== 1"
                              >
                                <a>Set as primary</a>
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </i-col>
                        <i-col :span="2" class="contact-control" v-else>
                          <Tooltip content="Primary" placement="left">
                            <Icon type="android-star"></Icon>
                          </Tooltip>
                        </i-col>
                      </Row>
                      <Row
                        v-for="(mobile, i) in mobileAdd"
                        :key="i+'a'"
                        type="flex"
                        :gutter="20"
                        align="middle"
                        style="padding:2px 0"
                      >
                        <i-col :span="20" class="section-label m">
                          <i-input v-model="mobileAdd[i].mobile" />
                        </i-col>
                        <i-col :span="2">
                          <Dropdown :transfer="true" placement="bottom-end">
                            <a style="padding:4px 0px; color: black;">
                              <Icon size="20" type="android-more-vertical"></Icon>
                            </a>
                            <DropdownMenu slot="list">
                              <DropdownItem
                                @click.native="removeMobile(false, mobileAdd[i].mobile)"
                              >
                                <a>Delete</a>
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </i-col>
                      </Row>
                      <Row style="margin-top: 8px;">
                        <i-col :span="6">
                          <Button @click="addMobile" size="small">
                            <small>Add New</small>
                          </Button>
                        </i-col>
                      </Row>
                    </i-col>
                  </Row>
                </div>
              </transition>
            </div>
          </i-col>
        </Row>
      </Card>
    </div>

    <!-- <UserProfileSettingSectionsComponent
      tag="social"
      :profile="profile"
      title="Social"
      :fieldslugs="['facebook','twitter', 'instagram', 'linkedin', 'website']"
      :tooltips="[
        '1. Log into Facebook, then click on your\nname in the upper right part of the screen.\n2. Copy your Facebook Profile URL in\nthe address bar of your browser.',
        '1. Log into Twitter, then at the upper right,\nnext to your image, click on your name\n to view your profile page.\n2. Copy your Twitter Profile URL in\nthe address bar of your browser.',
        '1. Log into Instagram, then click the \nperson icon at the upper right of the screen.\n2. Copy your Instagram Profile URL in\nthe address bar of your browser.',
        '1. Log into Linkedin, then click the Me icon\nat the top of your LinkedIn homepage.\n2. Copy your Linkedin Profile URL in\nthe address bar of your browser.',
        'Enter your website URL']"
      icon="ios-world"
      :hide-check="true"
      info="Manage your social network links">
    </UserProfileSettingSectionsComponent>
    <UserProfileSettingActivityComponent
      tag="documents"
      title="My Documents"
      icon="locked"
    info="Demo"/>-->
    <div class="save-button-wrapper">
      <i-button
        size="large"
        :loading="isSaving"
        :disabled="!enableBtn && !updateGallery && !setAvatarChange && !publicProfileToggleChange"
        @click="onSave()"
        type="primary"
        long
      >Save</i-button>
    </div>
    <AvatarPickerModal @avatarPick="avatarPick" />
    <UploadImageComponent ref="uploadImage" @emitBase64="onLoadImage"></UploadImageComponent>
  </div>
</template>

<script>
import UserProfileSettingSectionsComponent from "@/views/UserProfileSettingSectionsComponent";
import UserProfileSettingPasswordComponent from "@/views/UserProfileSettingPasswordComponent";
import UserProfileSettingActivityComponent from "@/views/UserProfileSettingActivityComponent";
import UserProfileGallery from "@/views/UserProfileSettingGalleryComponent";
import UploadImageComponent from "@/components/UploadImageComponent";
import NotificationSW from "@/components/PushNotificationEnabler";
import PublicProfileSW from "@/components/PublicProfileEnabler";
import MyOrganization from "@/components/MyOrganization";
import AvatarPickerModal from "@/components/AvatarPickerModal";
import _ from "lodash";
import { mapGetters } from "vuex";
import Utils from "@/utils.js";
import { Message } from "iview";
import { isValidNumber } from "libphonenumber-js";

export default {
  components: {
    UserProfileSettingSectionsComponent,
    UserProfileSettingPasswordComponent,
    UserProfileSettingActivityComponent,
    UploadImageComponent,
    UserProfileGallery,
    NotificationSW,
    PublicProfileSW,
    MyOrganization,
    AvatarPickerModal
  },
  data() {
    return {
      enableBtn: false,
      showUploadSelection: false,
      updateGallery: false,
      setAvatarChange: false,
      passwordChange: {},
      isSaving: false,
      updatedSlug: [],
      image: {
        changed: false,
        oldImage: "",
        newImage: ""
      },
      isAvatar: false, //this is when user selects an image from the avatar picker
      publicProfileToggleChange: false,
      isPublic: this.isPublicProfile,
      openContactInfo: false,
      profile: _.cloneDeep(this.$store.state.user.info),
      emailDelete: [],
      emailAdd: [],
      emailPrimary: "",
      mobileDelete: [],
      mobileAdd: [],
      mobilePrimary: "",
      showVerifyModal: false,
      verifyViaMobile: true,
      verifyCode: "",
      isVerifying: false,
      verifyTarget: ""
    };
  },
  // beforeRouteLeave(to, from, next) {
  //   if (this.image.changed || this.updatedSlug.length > 0) {
  //     this.$Message({
  //       closable: true,
  //       title: { content: "Save changes" },
  //       icon: "help",
  //       message: { content: "Do you want to save your changes?" },
  //       buttons: [
  //         {
  //           label: "Yes",
  //           type: "primary",
  //           hideAfter: true,
  //           action: () => {
  //             this.onSave();
  //             next();
  //           }
  //         },
  //         {
  //           label: "Cancel",
  //           type: "primary",
  //           hideAfter: true,
  //           action: () => next()
  //         }
  //       ]
  //     });
  //   } else {
  //     next();
  //   }
  // },
  created() {
    BroadcastEvent.$on("ONSETAVATARIMAGECHANGE", v => {
      this.setAvatarChange = true;
    });

    BroadcastEvent.$on("ONPASSWORDCHANGE", v => {
      this.enableBtn = v.success;
      this.passwordChange = v;
    });

    BroadcastEvent.$on("ONFIELDCHANGEPRIMARYORG", v => {
      this.profile.primary_org = v;
    });

    BroadcastEvent.$on("ONGALLLERYFIELDCHANGE", v => {
      this.updateGallery = true;
    });

    BroadcastEvent.$on("ONFIELDCHANGE", v => {
      this.enableBtn = true;

      if (this.updatedSlug.length <= 0) {
        this.updatedSlug.push(v);
        return false;
      }

      var indx = this.updatedSlug.indexOf(v);
      var exist = indx > -1;

      if (!exist) this.updatedSlug.push(v);
    });
  },
  methods: {
    validateMobile(mobile) {
      let res = new RegExp('[^\-+?+0-9]','g').exec(mobile)
      return mobile && isValidNumber(mobile) && !res
    },
    setMobilePrimary(mobile) {
      let primaryMobileIndex = _.findIndex(
        this.userInfo.mobile,
        item => item.primary === 1
      );

      let mobileIndex = _.findIndex(
        this.profile.mobile,
        item => item.mobile === mobile
      );

      this.mobilePrimary = mobile;

      for (let i = 0; i < this.profile.mobile.length; i++) {
        this.profile.mobile[i].primary =
          this.profile.mobile[i].mobile == mobile ? 1 : 0;
      }

      this.updateSaveButton();
    },
    setEmailPrimary(email) {
      let primaryEmailIndex = _.findIndex(
        this.userInfo.email,
        item => item.primary === 1
      );

      let emailIndex = _.findIndex(
        this.profile.email,
        item => item.email === email
      );

      this.emailPrimary = email;

      for (let i = 0; i < this.profile.email.length; i++) {
        this.profile.email[i].primary =
          this.profile.email[i].email == email ? 1 : 0;
      }

      this.updateSaveButton();
    },
    async sendVerification(isMobile, payload) {
      this.verifyViaMobile = isMobile;
      this.verifyTarget = payload;

      try {
        this.$store.commit("base/setLoadingPage", true, { root: 1 });
        if (isMobile)
          await this.$store.dispatch("user/mobileSendCode", payload);
        else await this.$store.dispatch("user/emailSendCode", payload);
        //open modal
        this.showVerifyModal = true;
      } catch (error) {
        Message.warning("Unable to send verification code");
      } finally {
        this.$store.commit("base/setLoadingPage", false, { root: 1 });
      }
    },
    async verify() {
      if (!this.verifyCode) {
        Message.warning("Verification code is required");
      } else {
        try {
          this.isVerifying = true;
          let data = await this.$store.dispatch(
            "user/verifyCode",
            this.verifyCode
          );

          //remove from emailAdd or mobileAdd
          if (this.verifyViaMobile) {
            let mobileIndex = _.findIndex(
              this.profile.mobile,
              item => item.mobile === this.verifyTarget
            );

            this.profile.mobile.splice(mobileIndex, 1, {
              ...this.profile.mobile[mobileIndex],
              validated_at: true
            });
          } else {
            let emailIndex = _.findIndex(
              this.profile.email,
              item => item.email === this.verifyTarget
            );

            this.profile.email.splice(emailIndex, 1, {
              ...this.profile.email[emailIndex],
              validated_at: true
            });
          }
          Message.success("Successfully verified !");
        } catch (error) {
          Message.warning(
            _.get(error, "response.data.error.message", "Invalid Code")
          );
        } finally {
          this.showVerifyModal = false;
          this.verifyCode = "";
          this.isVerifying = false;
        }
      }
    },
    updateSaveButton() {
      let primaryMobileIndex = _.findIndex(
        this.userInfo.mobile,
        item => item.primary === 1
      );

      let primaryEmailIndex = _.findIndex(
        this.userInfo.email,
        item => item.primary === 1
      );

      let mobilePrimaryUpdated = false;
      let emailPrimaryUpdated = false;

      if (primaryMobileIndex >= 0) {
        mobilePrimaryUpdated =
          this.userInfo.mobile[primaryMobileIndex].mobile !==
            this.mobilePrimary && this.mobilePrimary !== "";
      } else {
        mobilePrimaryUpdated = this.mobilePrimary !== "";
      }

      if (primaryEmailIndex >= 0) {
        emailPrimaryUpdated =
          this.userInfo.email[primaryEmailIndex].email !== this.emailPrimary &&
          this.emailPrimary !== "";
      } else {
        emailPrimaryUpdated = this.emailPrimary !== "";
      }

      this.enableBtn =
        mobilePrimaryUpdated ||
        emailPrimaryUpdated ||
        this.mobileDelete.length > 0 ||
        this.mobileAdd.length > 0 ||
        this.profile.mobile.length != this.userInfo.mobile.length ||
        this.emailDelete.length > 0 ||
        this.emailAdd.length > 0 ||
        this.profile.email.length != this.userInfo.email.length;
    },
    showConfirmDialog(title, message, action) {
      this.$Message({
        closable: false,
        title: { content: title },
        icon: "ios-trash",
        message: {
          content: message
        },
        buttons: [
          {
            label: "Yes",
            type: "error",
            hideAfter: true,
            action: action
          },
          {
            label: "Cancel",
            type: "primary",
            hideAfter: true,
            action: () => {}
          }
        ]
      });
    },
    removeMobile(fromApi, mobile) {
      this.showConfirmDialog(
        "Delete",
        "Are you sure you want to delete this mobile number ?",
        () => {
          if (fromApi) {
            let deleteIndex = _.findIndex(
              this.profile.mobile,
              item => item.mobile === mobile
            );
            this.mobileDelete.push(this.profile.mobile[deleteIndex]);
            this.profile.mobile.splice(deleteIndex, 1);
          } else {
            let deleteIndex = _.findIndex(
              this.mobileAdd,
              item => item.mobile === mobile
            );
            this.mobileAdd.splice(deleteIndex, 1);
          }
          this.updateSaveButton();
        }
      );
    },
    addMobile() {
      this.enableBtn = true;
      if (_.findIndex(this.mobileAdd, item => item.mobile === "") >= 0) return;
      this.mobileAdd.push({
        mobile: "",
        validated_at: "",
        primary: 0
      });
    },
    removeEmail(fromApi, email) {
      this.showConfirmDialog(
        "Delete",
        "Are you sure you want to delete this email address ?",
        () => {
          if (fromApi) {
            let deleteIndex = _.findIndex(
              this.profile.email,
              item => item.email === email
            );
            this.emailDelete.push(this.profile.email[deleteIndex]);
            this.profile.email.splice(deleteIndex, 1);
          } else {
            let deleteIndex = _.findIndex(
              this.emailAdd,
              item => item.email === email
            );
            this.emailAdd.splice(deleteIndex, 1);
          }
          this.updateSaveButton();
        }
      );
    },
    addEmail() {
      this.enableBtn = true;
      if (_.findIndex(this.emailAdd, item => item.email === "") >= 0) return;
      this.emailAdd.push({
        email: "",
        validated_at: "",
        primary: 0
      });
    },
    isEmailExist(email) {
      return (
        this.userInfo.email.findIndex(e => {
          return e.email === email;
        }) >= 0 ||
        this.emailAdd.findIndex(e => {
          return e.email === email;
        }) >= 0
      );
    },
    changePublic(v) {
      var isPublicValue = v ? 1 : 0;
      if (isPublicValue != this.isPublicProfile)
        this.publicProfileToggleChange = true;
      else this.publicProfileToggleChange = false;
      this.isPublic = isPublicValue;
    },
    avatarPick(avatar) {
      this.image.changed = true;
      this.image.newImage = avatar;
      this.enableBtn = true;
      this.isAvatar = true;

      BroadcastEvent.$emit("ONNEWIMAGECHANGE", avatar);

      this.disableSaveButton = false;
      this.setAvatarChange = false;

      // this.$store.commit("user/updateUserAvatar", avatar);
    },
    uploadImage() {
        this.openAvatarPicker();
      // if (this.userStory.data.user_story_type == "patient")
      //   this.openAvatarPicker();
      // else {
      //   this.showUploadSelection = true;
      // }
    },
    openAvatarPicker() {
      this.$store.commit("publicProfile/setAvatarPicker", true);
    },
    onLoadImage(image) {
      this.isAvatar = false;

      if (!this.image.changed) {
        this.image.oldImage = this.$store.state.user.info.avatar;
      }

      this.image.changed = true;
      this.image.newImage = image[0];
      this.enableBtn = true;

      if (image[0]) BroadcastEvent.$emit("ONNEWIMAGECHANGE", image[0]);

      this.disableSaveButton = false;
      this.setAvatarChange = false;
      // this.$store.commit("user/updateUserAvatar", image[0]);
    },
    async onSave() {
      this.isSaving = true;

      let updateFields = {};
      let profileData = this.profile;
      for (let x in this.updatedSlug) {
        if (
          this.updatedSlug[x] == "visible_fields" ||
          this.updatedSlug[x] == "primary_org"
        ) {
          updateFields["meta"] = {};
          updateFields["meta"][this.updatedSlug[x]] =
            profileData[this.updatedSlug[x]];
        } else {
          updateFields[this.updatedSlug[x]] = profileData[this.updatedSlug[x]];
        }
      }

      if (!this.profile.display_name || !this.profile.display_name.trim()) {
          Message.warning("Display name is required");
          this.isSaving = false;
          return;
      }

            let hasEmailValidationError = 0;
      let hasMobileValidationError = 0;

      //validate email
      this.emailAdd.forEach(element => {
        if (!Utils.validateEmail(element.email)) {
          Message.warning("Invalid email address format");
          hasEmailValidationError++;
        }
      });

      //remove duplicates
      this.emailAdd = _.uniqWith(this.emailAdd, (e, f) => {
        e.email === f.email;
      });

      // check if newly added email address has duplicates on already saved emails
      this.emailAdd.forEach(email => {
        if (
          _.findIndex(this.profile.email, item => item.email === email.email) >=
          0
        ) {
          Message.warning("Duplicate email address");
          hasEmailValidationError++;
        }
      });

      if (hasEmailValidationError > 0 || hasMobileValidationError > 0) {
        this.isSaving = false;
        return;
      }

      //validate mobile
      this.mobileAdd.forEach(element => {
        if (!this.validateMobile(element.mobile)) {
          Message.warning("Invalid mobile number format");
          hasMobileValidationError++;
        }
      });

      //remove duplicates
      this.mobileAdd = _.uniqWith(this.mobileAdd, (e, f) => {
        e.mobile === f.mobile;
      });

      // check if newly added mobile number has duplicates on already saved mobile numbers
      this.mobileAdd.forEach(mobile => {
        if (
          _.findIndex(
            this.profile.mobile,
            item => item.mobile === mobile.mobile
          ) >= 0
        ) {
          Message.warning("Duplicate mobile number");
          hasMobileValidationError++;
        }
      });

      if (hasEmailValidationError > 0 || hasMobileValidationError > 0) {
        this.isSaving = false;
        return;
      }

      let promises = [];

      //delete emails
      this.emailDelete.forEach(element => {
        promises.push(this.$store.dispatch("user/deleteEmail", element.email));
      });

      //add emails
      for (const element of this.emailAdd) {
        try {
          await this.$store.dispatch("user/addEmail", element.email)

          let elementIndex = _.findIndex(
            this.emailAdd,
            item => item.email === element.email
          );

          if (elementIndex >= 0) {
            this.emailAdd.splice(elementIndex, 1)
            this.profile.email.push(element)
          }
        } catch (e) {
          Message.warning(`${element.email} already in use`);
        }
      }

      //delete mobiles
      this.mobileDelete.forEach(element => {
        promises.push(
          this.$store.dispatch("user/deleteMobile", element.mobile)
        );
      });

      //add mobiles
      for (const element of this.mobileAdd) {
        try {
          await this.$store.dispatch("user/addMobile", {
            mobile: element.mobile,
            primary: 0
          });
          let elementIndex = _.findIndex(
            this.mobileAdd,
            item => item.mobile === element.mobile
          );

          if (elementIndex >= 0) {
            this.mobileAdd.splice(elementIndex, 1)
            this.profile.mobile.push(element)
          }
        } catch (e) {
          console.log(e.data)
          Message.warning(`${element.mobile} already in use`);
        }
      }

      //set primary email
      if (this.emailPrimary)
        this.$store.dispatch("user/setPrimaryEmail", this.emailPrimary);

      //set primary mobile
      if (this.mobilePrimary)
        this.$store.dispatch("user/setPrimaryMobile", this.mobilePrimary);

      await Promise.all(promises);

      if (this.mobileAdd.length != 0 || this.emailAdd.length != 0) {
        this.enableBtn = true;
        this.isSaving = false;
        return
      } 

      //reset email and mobile list
      // this.mobileAdd = [];
      this.mobileDelete = [];
      // this.emailAdd = [];
      this.emailDelete = [];

      updateFields.is_public = this.isPublic;

      if (this.updateGallery) {
        console.log("Saving gallery...");
        this.$store
          .dispatch("gallery/checkGallery", { id: this.profile.careplan_id })
          .then(res => {
            this.updateGallery = false;
            this.isSaving = false;
          });
      }

      // saving avatar block
      if (this.image.changed && this.image.newImage) {
        if (!this.isAvatar) {
          try {
            let res = await this.$store.dispatch(
              "publicModule/uploadBase64Image",
              {
                base64_image: this.image.newImage
              }
            );

            if (res && res.uploaded.length > 0 && res.uploaded[0]){
              await this.$store.dispatch("user/updateUserAvatar", {
                avatar: res.uploaded[0]
              });

              this.image = {
                changed: false,
                oldImage: "",
                newImage: ""
              };
            }
          }
          catch(e) {
            this.isSaving = false;
          }
        }
        else {
          try {
            await this.$store.dispatch("user/updateUserAvatar", {
              avatar: this.image.newImage
            });
            this.image = {
              changed: false,
              oldImage: "",
              newImage: ""
            };
          }
          catch(e) {
            this.isSaving = false;
          }
        }
      }

      // saving user profile block
      this.$store
        .dispatch("user/updateUserInfo", {
          id: this.profile.id,
          data: updateFields
        })
        .then(
          response => {
            this.$store.commit("publicProfile/setInfoData", response);

            if (this.passwordChange.success) {
              this.$store.dispatch(
                "user/changePassword",
                this.passwordChange
              );
              BroadcastEvent.$emit("PASSWORDCHANGED");
            }
            this.profile = _.cloneDeep(this.userInfo);
            
            this.enableBtn = false;
            this.updateGallery = false;
            this.setAvatarChange = false;
            this.publicProfileToggleChange = false;
            this.isSaving = false;
          },
          error => {
            this.enableBtn = false;
            this.updateGallery = false;
            this.setAvatarChange = false;
            this.publicProfileToggleChange = false;
            this.isSaving = false;
          }
        );
    }
  },
  beforeDestroy() {
    this.updatedSlug = [];
  },
  computed: {
    ...mapGetters("user", ["userInfo", "brandInfo"]),
    userStory() {
      return this.$store.state.library.userStory;
    },
    isPublicProfile() {
      return this.profile.is_public;
    },
    brandFieldSlugs(){
      let slugs = ['first_name','age','gender'];
      let hasGeneric = this.brandInfo.required_fields.indexOf('generic_id');
      if(hasGeneric > 0){
        slugs = ['first_name','age','gender','generic_id']
      }
      return slugs
    }
  },
  watch: {
    enableBtn(n) {
      this.$emit("hasChanges", n);
    }
  }
};
</script>

<style lang="scss">
.contact-control {
  display: flex !important;
  justify-content: center !important;
}
.contact-dropdown {
  .ivu-input-wrapper {
    .ivu-input-group-append {
      background: unset !important;
    }
    .ivu-input-group .ivu-input {
      border-radius: 4px;
      border-right: none;
    }
  }
}
</style>

<style lang="scss" scoped>
.save-button-wrapper {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0px;
  z-index: 2;
  width: 100%;
}

@media (min-width: 768px) and (max-width: 1024px) {
  .save-button-wrapper {
    width: 65%;
    transform: translateX(-31%);
  }
}

@media (min-width: 1025px) {
  .save-button-wrapper {
    width: 40%;
  }
}

.contact-verify {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .code-input {
    text-align: center;
    margin-bottom: 20px;
  }
  .ivu-input-wrapper {
    // width: 70%;
  }
}
.contact-dropdown {
  .add-margin {
    margin-bottom: 5px;
  }
  .section-header {
    font-weight: 700;
    color: #333;
  }
  .section-label {
    font-size: 11px;
    line-height: 20px;
    color: #aaa;
  }
  .section-value {
    min-height: 20px;
    display: block;
  }
  .m {
    color: #333;
  }
  .section-label.m {
    min-height: 33px;
    margin-top: 0;
  }
}
</style>